module.exports = __webpack_public_path__ + "static/web-845f10ad15dc8a87e5f933c172918b61.png";